module.exports = __webpack_public_path__ + "img/package_4.684d84cb.png";